// extracted by mini-css-extract-plugin
export default {"wrapper":"UpComingTask_wrapper__nZoi+","user-progress-title":"UpComingTask_user-progress-title__sPBpZ"};